var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.172,
    height: 53.198,
    viewBox: "0 0 53.172 53.198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slider",
    transform: "translate(-3.249 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M11.017,13.569A9.811,9.811,0,0,1,20.836,3.75h8.481a9.811,9.811,0,0,1,9.819,9.819v32.56a9.811,9.811,0,0,1-9.819,9.819H20.836a9.811,9.811,0,0,1-9.819-9.819Zm9.819-5.806a5.8,5.8,0,0,0-5.806,5.806v32.56a5.8,5.8,0,0,0,5.806,5.806h8.481a5.8,5.8,0,0,0,5.806-5.806V13.569a5.8,5.8,0,0,0-5.806-5.806Z",
    transform: "translate(4.398)",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M3.75,7.381A2.007,2.007,0,0,1,5.8,5.417,6.813,6.813,0,0,1,10.557,7.46a6.794,6.794,0,0,1,2.022,4.779V45.415a6.8,6.8,0,0,1-2.032,4.79l-.021.021A7.031,7.031,0,0,1,5.8,52.237a2.007,2.007,0,1,1-.085-4.012,3.018,3.018,0,0,0,2.005-.868,2.783,2.783,0,0,0,.846-1.942V12.239a2.786,2.786,0,0,0-.857-1.952l-.021-.021a2.8,2.8,0,0,0-1.973-.836A2.007,2.007,0,0,1,3.75,7.381Z",
    transform: "translate(0 1.009)",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M32.785,7.355a7.049,7.049,0,0,1,4.828-1.938,2.007,2.007,0,1,1,0,4.013,3.033,3.033,0,0,0-2.053.825,2.95,2.95,0,0,0-.863,2.008V45.442a2.887,2.887,0,0,0,.873,2,2.917,2.917,0,0,0,2.043.814,2.007,2.007,0,1,1,0,4.013,6.93,6.93,0,0,1-4.85-1.959l-.021-.02a6.9,6.9,0,0,1-2.059-4.844V12.2a6.965,6.965,0,0,1,2.059-4.8l.021-.021Z",
    transform: "translate(16.302 1.009)",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.e983ca1dc512fb28f354b8db7b71937c.svg";
export { ForwardRef as ReactComponent };